export default "__VITE_ASSET__D0_YEk5f__"